import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useEventCategoryQuery, useUpdateEventCategory } from "../api/queries";
import { EventCategoryForm } from "../ui/EventCategoryForm";

export function EventCategoryEditPage() {
  const { id } = useParams({
    from: "/app/performance/settings/event-categories/$id/edit",
  });
  const nav = useNavigate({
    from: "/app/performance/settings/event-categories/$id/edit",
  });
  const { data: category, isLoading } = useEventCategoryQuery(id);
  const updateCategory = useUpdateEventCategory(id);

  if (isLoading) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              {
                label: "ຫມວດງານສະແດງ",
                to: "/app/performance/settings/event-categories",
              },
              { label: "..." },
            ]}
          />
        </Header>
        <Main>
          <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
        </Main>
      </>
    );
  }

  if (!category) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              {
                label: "ຫມວດງານສະແດງ",
                to: "/app/performance/settings/event-categories",
              },
              { label: "ບໍ່ພົບ" },
            ]}
          />
        </Header>
        <Main>
          <p className="text-destructive">ບໍ່ພົບຫມວດງານ</p>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ຫມວດງານສະແດງ",
              to: "/app/performance/settings/event-categories",
            },
            { label: category.name },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂຫມວດງານ</h2>
          <p className="text-muted-foreground">{category.name}</p>
        </div>
        <div className="rounded-xl border bg-card px-6">
          <EventCategoryForm
            slugDisabled
            initialValues={{
              slug: category.slug,
              name: category.name,
              nameEn: category.nameEn,
              description: category.description,
              logoStorageKey: category.logoStorageKey,
              sortOrder: category.sortOrder,
              isActive: category.isActive,
            }}
            onSubmit={async (vals) => {
              try {
                await updateCategory.mutateAsync(vals);
                nav({ to: "/app/performance/settings/event-categories" });
              } catch {}
            }}
            onCancel={() =>
              nav({ to: "/app/performance/settings/event-categories" })
            }
            submitting={updateCategory.isPending}
          />
        </div>
      </Main>
    </>
  );
}
